import axios from 'axios'
import { CALL_API } from 'tr-components/redux/CallApiMiddlewareActionCreator'
import { fetchOptions } from '../../../config/endpoints'

const LOAD_FILE = 'formWizard/LOAD_FILE'
const LOAD_FILE_SUCCESS = 'formWizard/LOAD_FILE_SUCCESS'
const LOAD_FILE_FAIL = 'formWizard/LOAD_FILE_FAIL'
const LOAD_FORM = 'formWizard/LOAD_FORM'

const RESET_STATE = 'formWizard/RESET_STATE'
const SUBMIT_FORM = 'formWizard/SUBMIT_FORM'
const SUBMIT_FORM_SUCCESS = 'formWizard/SUBMIT_FORM_SUCCESS'
const SUBMIT_FORM_FAIL = 'formWizard/SUBMIT_FORM_FAIL'

export const actions = {
  LOAD_FILE,
  LOAD_FILE_SUCCESS,
  LOAD_FILE_FAIL,
  LOAD_FORM,
  RESET_STATE,
  SUBMIT_FORM,
  SUBMIT_FORM_SUCCESS,
  SUBMIT_FORM_FAIL
}

const meta = {}

export const defaultForm = {
  title: '',
  description: '',
  meta,
  sections: [
    {
      content: [],
      label: '',
      meta,
      title: ''
    }
  ],
  restrictions: {
    resettable: true,
    removable: true
  },
  workflow: ''
}

export const initialState = {
  formId: null,
  loadingFile: false,
  initialValues: null,
  submitting: false
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_FORM:
      return {
        ...state,
        initialValues: action.form ? action.form : defaultForm
      }
    case RESET_STATE:
      return {
        ...initialState
      }
    case SUBMIT_FORM:
      return {
        ...state,
        submitting: true
      }
    case SUBMIT_FORM_SUCCESS:
      return {
        ...state,
        formId: action.payload.id,
        versionId: action.payload.version,
        submitting: false
      }
    case SUBMIT_FORM_FAIL:
      return {
        ...state,
        submitting: false
      }
    default:
      return state
  }
}

export function loadFile({ file }) {
  const customParams = {
    ...fetchOptions('v2'),
    headers: {
      ...fetchOptions('v2').headers,
      'Content-Type': 'application/pdf'
    }
  }
  return {
    type: CALL_API,
    types: [LOAD_FILE, LOAD_FILE_SUCCESS, LOAD_FILE_FAIL],
    callAPI: () => axios.put('/content', file, { ...customParams }),
    payload: { file }
  }
}

export function loadForm(form) {
  return {
    type: LOAD_FORM,
    form
  }
}

export function resetState() {
  return {
    type: RESET_STATE
  }
}

export function submitForm(values) {
  return {
    type: CALL_API,
    types: [SUBMIT_FORM, SUBMIT_FORM_SUCCESS, SUBMIT_FORM_FAIL],
    callAPI: () => axios.post('/forms', values, { ...fetchOptions('v2') })
  }
}



// WEBPACK FOOTER //
// ./src/modules/Forms/reducers/formWizard.js